<template>
  <div>
    <b-card>
      <b-table
        responsive="sm"
        :fields="fields"
        :items="configs"
        details-td-class="m-0 p-0"
        small
        v-if="hasPermission('read_config')"
        :per-page="0"
      >
        <template #cell(manage)="row">
          <b-button
            variant="info"
            pill
            size="sm"
            class="mr-50"
            @click="editConfig(row.item)"
            v-if="hasPermission('update_config')"
          >
            Edit
          </b-button>
        </template>
      </b-table>
      <b-pagination
        size="md"
        :total-rows="totalItems"
        v-model="currentPage"
        :per-page="perPage"
      ></b-pagination>
    </b-card>
    <EditConfigModal
      :config="config"
      @modalClosed="onModalClosed"
      :key="`edit-${editConfigModalCount}`"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import EditConfigModal from "@/components/config/EditConfigModal.vue";
import util from "@/util.js";

export default {
  components: {
    EditConfigModal,
  },
  data() {
    return {
      fields: [
        { key: "android_pkg_name", label: "Android Package Name" },
        { key: "created_at", label: "Created At" },
        { key: "updated_at", label: "Updated At" },
        { key: "manage", label: "Manage" },
      ],
      currentPage: 1,
      perPage: 0,
      totalItems: 0,
      configs: [],
      config: null,
      createConfigModalCount: 0,
      editConfigModalCount: 0,
    };
  },
  mixins: [util],
  async mounted() {
    await this.fetchPaginatedData();
  },
  methods: {
    ...mapActions({
      getConfigs: "appData/getConfigs",
    }),
    async fetchPaginatedData() {
      try {
        const res = await this.getConfigs({
          pageNumber: this.currentPage,
        });
        this.configs = res.data.results;
        this.totalItems = res.data.count;
        this.perPage = res.data.per_page;
      } catch (error) {
        this.displayError(error);
      }
    },
    editConfig(config) {
      this.config = config;
      this.editConfigModalCount += 1;
      this.$nextTick(() => {
        this.$bvModal.show("edit-config-modal");
      });
    },
    async onModalClosed() {
      await this.fetchPaginatedData();
    },
  },
  computed: {
    ...mapGetters({
      hasPermission: "appData/hasPermission",
    }),
  },
  watch: {
    currentPage: async function (val) {
      await this.fetchPaginatedData();
    },
  },
};
</script>

<style></style>
